import {customElement, bindable, inject} from 'aurelia-framework';

@customElement('sio-booking-state-list')
export class BookingStateList
{
    @bindable
    bookingStatus;

}
